import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Autocomplete, Select, TextField, IconButton, Trash02Icon } from '@metarouter-private/mr-mui';

import { PAYLOAD_CONDITION_OPERATOR_OPTIONS } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext/PAYLOAD_CONDITION_OPERATORS';
import SEARCH_BAR_PROPS from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableHeader/EventSearch/EventSearchBar/shared/SEARCH_BAR_PROPS';

import usePayloadConditionRowProps from './usePayloadConditionRowProps';

const PATH_PLACEHOLDER = 'e.g. properties.products[*].brand';

export default function PayloadConditionRow({ condition }) {
  const { payloadPaths, valueDisabled, onPathChange, onOperatorChange, onValueChange, onRemove } =
    usePayloadConditionRowProps(condition);

  return (
    <Grid container alignItems="center" spacing={1} flexWrap="nowrap" data-test-id="payloadConditionRow">
      <Grid item xs={5}>
        <Autocomplete
          {...SEARCH_BAR_PROPS}
          freeSolo
          openOnFocus
          label="Field Path"
          placeholder={PATH_PLACEHOLDER}
          options={payloadPaths}
          inputValue={condition.path}
          onChange={onPathChange}
          onInputChange={onPathChange}
          data-test-id="payloadConditionPath"
        />
      </Grid>

      <Grid item xs={2}>
        <Select
          {...SEARCH_BAR_PROPS}
          label="Operator"
          options={PAYLOAD_CONDITION_OPERATOR_OPTIONS}
          value={condition.operator}
          onChange={onOperatorChange}
          data-test-id="payloadConditionOperator"
        />
      </Grid>

      <Grid item flexGrow={1}>
        <TextField
          {...SEARCH_BAR_PROPS}
          label="Value"
          value={valueDisabled ? '' : condition.value}
          onChange={onValueChange}
          disabled={valueDisabled}
          inputProps={{ 'data-test-id': 'payloadConditionValue' }}
        />
      </Grid>

      <Grid item>
        <IconButton onClick={onRemove} data-test-id="payloadConditionRemove">
          <Trash02Icon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

PayloadConditionRow.propTypes = {
  condition: PropTypes.shape({
    id: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    operator: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};
